(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .factory('AppraisalFirmSearch', AppraisalFirmSearch);

    AppraisalFirmSearch.$inject = ['$resource'];

    function AppraisalFirmSearch($resource) {
        var resourceUrl =  'api/_search/appraisal-firms/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
